import _ from 'lodash';
import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyChecklistResults = createSelector(
  selectSubCompany,
  subCompany => subCompany?.checklists || [],
);

// Left-menu subtabs, one per checklist — mirrors the loan editor's Alerts section
// (getSubtabsFromChecklistResults). Failing checklists sort first, then by name, so
// the most actionable items sit at the top of the menu.
export const selectSubCompanyChecklistSubtabs = createSelector(
  selectSubCompanyChecklistResults,
  results =>
    _.orderBy(
      results.map(({ checklist, calculatedResult }) => ({
        checklistId: checklist?.id,
        label: checklist?.name,
        calculatedResult: !!calculatedResult,
      })),
      [({ calculatedResult }) => (calculatedResult ? 1 : 0), 'label'],
      ['asc', 'asc'],
    ),
);

export const selectSubCompanyChecklistsFormattedValues = createSelector(
  selectSubCompanyChecklistResults,
  results =>
    results.map(({ checklist, items, ...rest }) => {
      const resultItemsMap = _.keyBy(items, 'checklistItemId');

      return {
        ...rest,
        items,
        checklist: {
          ...checklist,
          categories: _.sortBy(checklist?.categories, 'orderSequence').map(category => {
            const { items: categoryItems, ...categoryRest } = category;

            return {
              ...categoryRest,
              items: categoryItems?.map(item => ({
                ...item,
                calculations: resultItemsMap[item.id],
              })),
            };
          }),
        },
      };
    }),
);
